"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingGapsPage = OnboardingGapsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var luam_screen_1 = require("./luam-screen");
/*
 * MC&LCC-2: the page shell for the LUAM screen.
 *
 * Titled "Onboarding Gaps" rather than LUAM — it is what Erik calls the button the user arrives from,
 * and the acronym means nothing to whoever lands here from a link.
 *
 * `?buildingId=` lets the prompt on the area, asset, meter and preliminary-bill screens hand over the
 * asset the user was already looking at, instead of dropping them on whichever one has the most work.
 */
function OnboardingGapsPage() {
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var buildingId = searchParams.get("buildingId") || undefined;
    return (
    /*
      `min-w-0` is load-bearing: a flex child defaults to `min-width: auto`, so a wide child — the
      building-area table — refuses to shrink and widens the whole PAGE instead of scrolling inside its
      own container. That is what put a horizontal scrollbar under the entire screen and clipped the
      sections further down.
    */
    (0, jsx_runtime_1.jsxs)("div", { className: "flex min-w-0 flex-col gap-4 md:gap-6", children: [(0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-semibold text-gray-900 md:text-2xl", children: "Onboarding Gaps" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "Link the premises and meters the metering company reports to the areas, services and meters they represent in Let'sCue." })] }) }), (0, jsx_runtime_1.jsx)(luam_screen_1.LuamScreen, { initialBuildingId: buildingId })] }));
}
